export const ABAS_DEFAULT = ['ResCart', 'PerfHist', 'PosCon', 'RetornoAtivo', 'FluxoAtivo', 'FluxoCaixa', 'EstatAvancada'];
